module.exports = __webpack_public_path__ + "6TbRXKWJjpj6V2v_WyRbMevvDin1pK8aKteLpeZ5c0A.4da7195e0c39f073119a.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/6TbRXKWJjpj6V2v_WyRbMevvDin1pK8aKteLpeZ5c0A.woff2
// module id = ../../../../../src/assets/fonts/font-google/6TbRXKWJjpj6V2v_WyRbMevvDin1pK8aKteLpeZ5c0A.woff2
// module chunks = 40